import { cn } from "@/lib/utils";

/** Retrato circular de Renata (sin wordmark). */
export const RENATA_AVATAR_SRC = "/brand/renata-avatar.png";
/** Arte completo con wordmark — uso en pantallas grandes. */
export const RENATA_PORTRAIT_SRC = "/brand/renata.png";

const SIZE = {
  xs: "h-6 w-6",
  sm: "h-7 w-7",
  md: "h-9 w-9",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
} as const;

export function RenataAvatar({
  size = "md",
  className,
  alt = "Renata",
}: {
  size?: keyof typeof SIZE;
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src={RENATA_AVATAR_SRC}
      alt={alt}
      width={48}
      height={48}
      decoding="async"
      className={cn("shrink-0 rounded-full bg-black object-cover", SIZE[size], className)}
    />
  );
}
